<template>
  <div class="tabscontens">
    <div class="ultabs"  v-if="showUl">
      <ul>
        <li
          v-for="(item, index) in contentsList"
          :key="item.title"
          :class="showIn(item.title)"
          @click="changeshow(index)"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
    <div class="title">
      <span class="line left"><img src="./jpg/goldLeft.png" alt="" /></span>
      <h3 class="contentTitle">{{ showSet }}</h3>
      <span class="line right"><img src="./jpg/goldRight.png" alt="" /></span>
    </div>
    <div class="contentsShow">
      <p v-for="item in showContents" :key="item">{{ item }}</p>
    </div>
    <div class="slotSet">
        <slot></slot>
        <slot name="footer" v-if="showZB"></slot>
        <slot name="header" v-if="showLX"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "dwgwtabs",
  props: ["contentsList"],
  computed: {
    showSet() {
      return this.contentsList[this.index].title;
    },
    showContents() {
      return this.contentsList[this.index].contentData;
    },
    showUl(){
        return this.contentsList.length > 1 ? true:false;
    },
    showZB(){
      return this.index ===0 ? true:false;
    },
    showLX(){
      return this.index ===0 ? false:true;
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    showIn(title) {
      return title == this.showSet ? "showIn" : "showout";
    },
    changeshow(index) {
      this.index = index;
    },
  },
};
</script>

<style scoped>
.tabscontens {
  background-color: #fff;
  position: relative;
  box-shadow: 0 0 8px 4px rgba(92, 77, 36, 0.08);
  text-align: center;
  width: 750px;
  margin: auto;
  margin-top: -100px;
  min-height: 400px;
  padding: 40px 100px;
}
.ultabs {
  height: 100px;
}
ul {
  float: right;
  width: 100%;
  border-bottom: 1px solid #ebe7e3;
}
li {
  float: left;
  list-style: none;
  padding: 0 14px;
  height: 100%;
  line-height: 100px;
  cursor: pointer;
}
ul > li:nth-child(2) {
  float: right;
  margin-right: 20%;
}
ul > li:nth-child(1) {
  float: left;
  margin-left: 20%;
}
.showIn {
  border-bottom: 2px solid #c8ad6d;
  color: #c8ad6d;
}
.title {
  height: 100px;
  line-height: 100px;
}

.contentTitle {
  display: inline-block;
  font-size: 30px;
  color: #555;
  text-align: center;
  margin: 0 50px;
  font-weight: inherit;
}

.line > img {
  vertical-align: middle;
  padding-bottom: 10px;
  width: 75px;
}
p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  margin: 0 0 10px;
  color: #666;
  font-size: 14px;
  line-height: 32px;
  text-indent: 32px;
  text-align: justify;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwcontenstabs.vue